"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionInfoPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="opt-desc" data-desc="audience" aria-live="polite">
    <i class="simple-icon-${x => x.showing ? 'arrow-right-circle' : 'bulb'}"></i><span class="text-muted">${(0, fast_element_1.when)(x => x.currentLabel, (0, fast_element_1.html) `<strong>${x => x.currentLabel} - </strong>`)}${x => x.text}</span>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.opt-desc {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-height: 58px;
  margin-top: 10px;
  padding: 9px 12px;
  border-left: 3px solid var(--primary-color);
  border-radius: 8px;
  background: var(--chat_header_color);
  color: var(--text_color);
  font-size: 0.82rem;
  line-height: 1.45;
}
.opt-desc strong {
  color: #000;
}
.opt-desc i {
  margin-top: 4px;
  color: var(--primary-color);
}`;
const shadowOptions = { "mode": "open" };
let OptionInfoPart = class OptionInfoPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.currentLabel = null;
        this.showing = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.placeholder) {
            this.text = this.placeholder;
        }
        this.parentComponent = this.shadowRoot.host.parentElement.getRootNode().host;
        if (!this.eventListener && !this.eventListenerUndo) {
            this.eventListener = this.parentComponent.on('form-part:option:hover', this.handleHoverEvent.bind(this));
            this.eventListenerUndo = this.parentComponent.on('form-part:option:unhover', this.handleHoverUndoEvent.bind(this));
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.eventListener) {
            this.eventListener();
        }
        if (this.eventListenerUndo) {
            this.eventListenerUndo();
        }
    }
    handleHoverEvent(e) {
        if (e.detail.name === this.name) {
            this.text = e.detail.info;
            this.currentLabel = e.detail.label;
            this.showing = true;
            console.log('hhover');
        }
    }
    handleHoverUndoEvent(e) {
        if (e.detail.name === this.name) {
            this.showing = false;
            this.currentLabel = null;
            this.text = this.placeholder;
        }
    }
};
exports.OptionInfoPart = OptionInfoPart;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], OptionInfoPart.prototype, "name", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], OptionInfoPart.prototype, "placeholder", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof client_1.RWSViewComponent !== "undefined" && client_1.RWSViewComponent) === "function" ? _a : Object)
], OptionInfoPart.prototype, "parentComponent", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OptionInfoPart.prototype, "text", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], OptionInfoPart.prototype, "currentLabel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OptionInfoPart.prototype, "showing", void 0);
exports.OptionInfoPart = OptionInfoPart = __decorate([
    (0, client_1.RWSView)('part-option-info', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], OptionInfoPart);
OptionInfoPart.defineComponent();
